import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ButtonBase from '@material-ui/core/ButtonBase'
import WbTwilightIcon from 'components/material-symbol/icons/WbTwilight'
import LightModeIcon from 'components/material-symbol/icons/LightMode'
import DarkModeIcon from 'components/material-symbol/icons/DarkMode'
import { formatSlotLabel } from '../utils'
import useStyles from './styles'

const DAY_PARTS = [
  { key: 'morning', label: 'Morning', Icon: WbTwilightIcon },
  { key: 'afternoon', label: 'Afternoon', Icon: LightModeIcon },
  { key: 'evening', label: 'Evening', Icon: DarkModeIcon },
]

const TimeSlotGroups = ({ slotsByPart, timezone, selectedSlot, onSelect }) => {
  const classes = useStyles()
  return DAY_PARTS.map(({ key, label, Icon }) => {
    const slots = slotsByPart[key]
    if (!slots || slots.length === 0) return null
    return (
      <section
        key={key}
        className={classes.dayPart}
        aria-labelledby={`day-part-${key}`}
      >
        <h3 id={`day-part-${key}`} className={classes.dayPartHeader}>
          <Icon aria-hidden="true" />
          {label}
        </h3>
        <div className={classes.slotGrid}>
          {slots.map(ts => {
            const isSelected = ts === selectedSlot
            return (
              <ButtonBase
                key={ts}
                className={clsx(
                  classes.slot,
                  isSelected && classes.slotSelected,
                )}
                aria-pressed={isSelected}
                onClick={() => onSelect(ts)}
                data-testid="time-slot-button"
              >
                {formatSlotLabel(ts, timezone)}
              </ButtonBase>
            )
          })}
        </div>
      </section>
    )
  })
}

TimeSlotGroups.propTypes = {
  slotsByPart: PropTypes.shape({
    morning: PropTypes.arrayOf(PropTypes.string),
    afternoon: PropTypes.arrayOf(PropTypes.string),
    evening: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  timezone: PropTypes.string,
  selectedSlot: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
}

export default TimeSlotGroups
